import { FC, useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader } from './dialog';

interface Props {
  show: boolean;
  onClose: () => void;
}

const AgentUpdateModal: FC<Props> = ({ show, onClose }) => {
  return (
    <Dialog open={show} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="font-bold">
          You’re just a few steps away from your own branded PropertyTaxHero
          setup.
        </DialogHeader>
        <div>
          <p>
            Add your phone number, website, brokerage name, and license number
            to get started.
          </p>
          <br />
          <p>
            Then invite your people — clients, friends, neighbors, and anyone in
            your network. Got a list? Upload it with a simple spreadsheet and
            you’re ready to roll. You can then send a quick email invite and let
            PropertyTaxHero do the rest — all beautifully branded to keep you
            top of mind.
          </p>
          <p>
            Be sure to copy your personal URL below and post it on social media.
            When someone uses your link, they’ll land on a PropertyTaxHero page
            featuring <strong>your</strong> photo, <strong>your</strong>{' '}
            branding, and <strong>your</strong> contact info.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AgentUpdateModal;
